import * as d3Import from 'd3';
import React, { useEffect, useRef } from 'react';
import { D3Props } from '../common-types';

/**
 * Props for a {@link D3Axis} component.
 * @author agd
 */
export interface D3AxisProps extends D3Props {
  /**
   * Axis height.
   */
  h: number;
  /**
   * Axis created using d3.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  axis: any;
  /**
   * Axis type.
   */
  axisType: 'x' | 'y';
}

/**
 * D3Axis component for drawing an x- or y-axis using d3.
 *
 * @param props a {@link D3AxisProps} object
 * @return the created {@link JSX.Element}
 * @constructor
 * @author agd
 */
export function D3Axis(props: D3AxisProps): JSX.Element {
  const d3 = props.d3 ?? d3Import;
  if (!d3.select) {
    throw new Error(
      "Some required d3 dependencies are missing. Make sure that at least 'd3-select'is on the page and accessible by the D3Axis"
    );
  }

  const axisRef = useRef(null);
  useEffect(() => {
    d3.select?.(axisRef.current).call(props.axis);
  }, [props.axis, d3]);

  const translate =
    props.axisType == 'x' ? `translate(0,${props.h})` : `translate(-10, 0)`;
  return <g className="axis" transform={translate} ref={axisRef} />;
}
